import { Typography } from "@mui/material";
import React from "react";

function Footer() {
  return (
    <Typography
      variant="body2"
      style={{ margin: 10 }}
      color="textSecondary"
      align="center"
    >
      Solution by bizX POS | 077 209 7766 | bizx@titum.lk
      <br />
      {"Copyright © "}
      Titum {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

export default Footer;
